// App constants

export const appName = 'Virtus Admin';
export const appEnv = __ENVIRONMENT__.toUpperCase();
export const appWebName = 'Virtus Admin Web App';
export const loginLocation = 'Virtus Admin Web';
export const defaultTelemetryApiName = 'NexusApi';
export const defaultTelemetryType = 'GetApiExceptions';
